import '@d3fc/d3fc-element';
import { seriesSvgPoint } from '@d3fc/d3fc-series';
import {
    OrderFill,
    deriveOrderFillBucketFillPrice,
    deriveOrderFillBucketMidTime,
} from 'widgets/fillsGraph/fillsGraphData';
import { Selection, BaseType } from 'd3-selection';
export const fillBlobSize = 10;

export const fillPricePoints = () => {
    const pointSymbol = {
        draw: function (context: CanvasRenderingContext2D, size: number) {
            context.lineWidth = 1;
            context.arc(0, 0, size / 2, 0, 2 * Math.PI);
            context.closePath();
        },
    };
    return seriesSvgPoint()
        .crossValue(deriveOrderFillBucketMidTime)
        .mainValue(deriveOrderFillBucketFillPrice)
        .size(fillBlobSize)
        .type(pointSymbol)
        .decorate((s: Selection<BaseType, OrderFill, null, unknown>) => {
            s.classed(
                'fill-price-point',
                (d: OrderFill) => !!deriveOrderFillBucketFillPrice(d)
            );
            s.style('display', (d: OrderFill) =>
                !deriveOrderFillBucketFillPrice(d) ? 'none' : 'initial'
            );
        });
};
